import Select from "common-ui-components/components/select";
import { useTableManagerContext } from "../../TableManagerContext";
import styles from "./Filter.module.css";
import { buildFilterSection } from "./FilterConfigBuilder";
import { useEffect } from "react";

const QuickFilters = ({ filterConfig, setFiltersForSaving }) => {
    const { filter, setFilter } = useTableManagerContext();
    const initialConfig=filterConfig;

    const handleQuickFilterChange = (column, options, option, index) => {
        const newFilter = filter.filter((f) => f.column !== column);
        if (!option.toLowerCase().includes("all")) {
            newFilter.push({ column, filterValue: options[index].value });
        }
        setFilter(newFilter);
       
        const updatedConfig = filterConfig.map(section => ({
            ...section,
            options: section.options.map(option => ({
                ...option,
                value:Array.isArray(option.value) && option.value.length === 1 ? option.value[0] : option.value,
            })),
        }));

        setFiltersForSaving((prev) => ({
            ...prev,
            quick_filters: buildFilterSection(newFilter, updatedConfig),
        }));
    };


    useEffect(()=>{
        // {
        //     "column": "alertPolicyPriority",
        //     "option": "High"
        // }
        const stored = localStorage.getItem("quickFilterToSet");
        if (!stored) return;
        const quickFilterToSet = JSON.parse(stored);

        const getActiveIndex = (filterConfig, column, label) => {
            const filter = filterConfig.find(
                (item) => item.column === column
            );
            if (!filter) return -1;
            return filter.options.findIndex(
                (option) => option.label === label
            );
        };

        const colName=quickFilterToSet?.column;
        const option=quickFilterToSet?.option;
        const activeIndex=getActiveIndex(filterConfig,colName,option);
        const options=filterConfig.find((filter) => filter.column === colName)?.options || [];

        if(options.length===0)
            return;
        const updatedFilterConfig = filterConfig.map((filter) => {
            if (filter.column !== colName)
                return filter;
            return {
                ...filter,
                options: filter.options.map((option, index) => ({
                ...option,
                initially_active: index === activeIndex,
                })),
            };
        });

        filterConfig=updatedFilterConfig;
        handleQuickFilterChange(colName, options, option, activeIndex)
        localStorage.removeItem("quickFilterToSet");
    },[])

    return (
        <div className={styles.QuickFilters}>
            {filterConfig.map(({ column, options }) => {
                // Compute the active index for this specific dropdown
                const currentFilter = filter.find((f) => f.column === column);
                const activeIdx = currentFilter
                ? options.findIndex(
                    (opt) =>
                        JSON.stringify(opt.value) ===
                        JSON.stringify(currentFilter.filterValue),
                    )
                : options.findIndex((option) => option.initially_active);
                return (
                    <Select
                        key={column}
                        options={options.map((opt) => opt.label)}
                        active={Math.max(activeIdx, 0)}
                        triggerProps={{
                            style: {
                                padding: "0.325rem 0.8rem",
                                border: "0.103rem solid",
                                borderColor: "#E0E0E0",
                                borderRadius: "1rem",
                                fontSize: "14px",
                            },
                        }}
                        iconProps={{ size: 12 }}
                        onOptionSelect={(...args) =>{
                            filterConfig=initialConfig;
                            handleQuickFilterChange(column, options, ...args)
                        }
                        }
                    />
                );
            })}
        </div>
    );
};
export default QuickFilters;
